import $ from 'jquery';

export default function bind() {
  $('div.checkBoxList input[type=text]').each((index, element) => {
    const $input = $(element);
    const inputName = $input.attr('name');

    const $checkbox = $input
      .closest('.checkBoxList')
      .find(`input[name="${inputName}Check"]`);

    $checkbox.on('change', evt => {
      const checked = $(evt.target)
        .parent()
        .hasClass('checked');
      if (checked) {
        $input.removeAttr('disabled');
      } else {
        $input.attr('disabled', 'disabled');
        $input.val('');
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src/plugins/multiref-checkboxes.js